// removed by extract-text-webpack-plugin
module.exports = {"projectPropertyCell":"_3TNGsPB78BPgKVn0Cc7abJ","imageSection":"_2tI4pgDeSSiWswM9xjyw_u","image":"_1rhzmEaQl8rnoG8be_DGi1","descriptionSection":"_2CzBExNQ0t9meNGpvtlUul","topBlock":"_2GQISY6N3m-TwxEyhGZlCC","price":"_36Ek3LbGVt2nk82CokxiK6","propertyType":"_3-w_irbMXoKj4n2AmbswP7","summaryBlock":"dlxq-K41xz4qRIf1LxHTN","title":"LoDemnVpmXOVWXQuCNLlT","info":"cX6p-OfsC7R86vRI9vPTa","showMore":"_1bduNCqoSLCHWsC3mAyWH6","photoWrapper":"_3L0HjP2bJ9BqTAzOKd04Zd","buttonShow":"_2famLF1Pp6OFbAcTBSzcax","showOriginalDescription":"_2ve_imLY1zHS_9EmtTgRJP","sub":"_1XtTQF1BT-Yc_78vhTlOKV"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProjectPropertyCell/ProjectPropertyCell.scss
// module id = 1713
// module chunks = 0